import { render, staticRenderFns } from "./SpecialArticle.vue?vue&type=template&id=cafcc116&scoped=true&"
import script from "./SpecialArticle.vue?vue&type=script&lang=js&"
export * from "./SpecialArticle.vue?vue&type=script&lang=js&"
import style0 from "./SpecialArticle.vue?vue&type=style&index=0&id=cafcc116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafcc116",
  null
  
)

export default component.exports